import React, { useEffect } from 'react';
import {
  IconX,
  IconChevronLeft,
  IconCheck,
  IconWorld
} from '@tabler/icons-react';
import { getFlagCode } from '../../utils/countryUtils';

const LocationStep = ({
  nodes,
  nodesLoading,
  selectedNode,
  onSelectNode,
  onCreate,
  loading,
  onBack,
  onClose,
}) => {
  useEffect(() => {
    console.log('LocationStep nodes:', nodes);
    console.log('LocationStep selectedNode:', selectedNode);
  }, [nodes, selectedNode]);

  const getNodeName = (node) => {
    if (node.name) return node.name;
    if (node.country) return node.country;
    if (node.city) return node.city;
    if (node.public_host) return node.public_host;
    if (node.host) return node.host;
    return 'Unknown';
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-dark-950/80 backdrop-blur-sm">
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/css/flag-icons.min.css" />
      <div className="bg-dark-900 border border-dark-800 rounded-2xl max-w-2xl w-full p-6 max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <button
              onClick={onBack}
              className="p-2 text-dark-500 hover:text-white hover:bg-dark-800 rounded-lg transition-colors"
            >
              <IconChevronLeft className="w-5 h-5" />
            </button>
            <h2 className="text-xl font-semibold text-white">Выберите сервер</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-dark-500 hover:text-white hover:bg-dark-800 rounded-lg transition-colors"
          >
            <IconX className="w-5 h-5" />
          </button>
        </div>

        {/* Description */}
        <p className="text-dark-500 text-sm mb-4">
          Выберите сервер для создания туннеля
        </p>

        {/* Nodes grid */}
        {nodesLoading ? (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-dark-500">Загрузка серверов...</div>
          </div>
        ) : nodes && nodes.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 overflow-y-auto flex-1 mb-6">
            {nodes.map(node => (
              <button
                key={node.id || Math.random()}
                onClick={() => onSelectNode(node)}
                className={`p-4 rounded-xl transition-all text-left border ${
                  selectedNode?.id === node.id
                    ? 'bg-primary-500/10 border-primary-500'
                    : 'bg-dark-950 border-dark-800 hover:border-dark-700'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className={`fi fi-${getFlagCode(node.flag)} text-3xl rounded overflow-hidden`}></span>
                  <span className="text-white font-medium">{getNodeName(node)}</span>
                </div>
              </button>
            ))}
          </div>
        ) : (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-dark-500">Нет доступных серверов</div>
          </div>
        )}

        {/* Create button */}
        <button
          onClick={onCreate}
          disabled={loading || !selectedNode}
          className="w-full py-3 bg-primary-500 hover:bg-primary-600 rounded-lg font-semibold text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {loading ? (
            <span>Создание...</span>
          ) : (
            <>
              <IconCheck className="w-5 h-5" />
              <span>Создать туннель</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default LocationStep;